import React, { useMemo } from 'react';
import { View, StyleSheet, Platform, Pressable } from 'react-native';
import { useRouter } from 'expo-router';
import Text from '@/components/Typography/Text';

function TopicTagChips({ tags, accent }) {
  const router = useRouter();
  const list = useMemo(
    () => (Array.isArray(tags) ? tags : []).filter((tag) => tag?.slug && tag?.name),
    [tags],
  );

  const styles = useMemo(() => StyleSheet.create({
    row: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 10,
      rowGap: 12,
      alignItems: 'center',
    },
    chip: {
      borderRadius: 999,
      borderWidth: 1,
      borderColor: `${accent}45`,
      backgroundColor: `${accent}16`,
      paddingHorizontal: 16,
      paddingVertical: 10,
      minHeight: 40,
      justifyContent: 'center',
      alignItems: 'center',
      ...(Platform.OS === 'web' ? { cursor: 'pointer' } : null),
    },
    chipPressed: {
      opacity: 0.88,
    },
    chipHovered: {
      backgroundColor: `${accent}24`,
      borderColor: `${accent}60`,
    },
    label: {
      lineHeight: 20,
    },
  }), [accent]);

  if (!list.length) return null;

  return (
    <View style={styles.row}>
      {list.map((tag) => (
        <Pressable
          key={tag.id || tag.slug}
          accessibilityRole="link"
          onPress={() => router.push(`/tags/${encodeURIComponent(tag.slug)}`)}
          style={({ pressed, hovered }) => [
            styles.chip,
            Platform.OS === 'web' && hovered && !pressed && styles.chipHovered,
            pressed && styles.chipPressed,
          ]}
        >
          <Text size="m" weight="semibold" color="primary" style={styles.label}>
            {tag.name}
          </Text>
        </Pressable>
      ))}
    </View>
  );
}

export default React.memo(TopicTagChips);
